import React from 'react';
import { Donor } from '../../models/Donor';
import { DonorReview } from '../../models/DonorReview';

type ReviewListProps = {
  donor: Donor;
}

const ReviewList = (props: ReviewListProps) => {
  const { donor } = props;
  const reviews = donor.reviews;
  const summary = donor.reviewSummary;

  if (!summary || summary.reviewCount === 0 || summary.isHidden) {
    return (
      <>
        <h2 className="main_title" id="review-list"><span>レビュー</span></h2>
        <div className="prof_contents">
          <p>まだレビューがありません。</p>
        </div>
      </>
    );
  }

  // 星の数ごとの分布を計算
  const distribution = [ 5, 4, 3, 2, 1 ].map(star => {
    const count = reviews.filter(r => r.score === star).length;
    const percentage = summary.reviewCount > 0 ? (count / summary.reviewCount) * 100 : 0;
    return { star, count, percentage };
  });

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('ja-JP', {
      year: 'numeric',
      month: '2-digit'
    });
  };

  return (
    <>
      <h2 className="main_title" id="review-list"><span>レビュー</span></h2>
      <div className="prof_contents">
        <section className="review-section">
          <div className="review-summary-detail">
            <div className="review-average">
              <div className="review-score-large">{ summary.averageScore }</div>
              <div className="review-stars-large">{ summary.stars }</div>
              <div className="review-count-text">{ summary.reviewCount }件のレビュー</div>
            </div>
            <div className="review-distribution">
              { distribution.map(({ star, count, percentage }) => (
                <div key={ star } className="distribution-row">
                  <span className="distribution-star">{ star } ★</span>
                  <div className="distribution-bar-container">
                    <div
                      className="distribution-bar"
                      style={{ width: `${ percentage }%` }}
                    />
                  </div>
                  <span className="distribution-count">{ count }</span>
                </div>
              ))}
            </div>
          </div>

          <div className="review-list">
            { reviews.map((review: DonorReview) => (
              <div key={ review.id } className="review-item">
                <div className="review-header">
                  <span className="review-author">{ review.donee.name.split('').join('.') }</span>
                  <span className="review-age">（{ review.ageRangeText }）</span>
                  <span className="review-date">{ formatDate(review.createdAt) }</span>
                </div>
                <div className="review-stars-inline">{ review.stars }</div>
                <div className="review-comment">{ review.comment }</div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}

export default ReviewList;
